// Note: These three must remain at the top of the file, and Tailwind CSS must be
// the first import to avoid those styles overwriting Xbox styles.
import "./tailwind.css";
import "@ms-mwf/moray/dist/css/themes/main-xbox.css";
import "./polyfills";
import "@gaming/xds-tokens-web/assets/fonts.css";

import { partnerConfigurations } from "configs/partnersConfig";
import React from "react";

import {
  App,
  initializeClient,
  InitializeClientOptions,
  LocationTracker,
} from "@gamedev-web/gamedev-foundation";

import { correlationVector, registerGtlClientSide } from "./telemetry/gtlProvider";

const clientOptions: InitializeClientOptions = {
  app: () => (
    <LocationTracker>
      <App />
      <div id="cv" data-cv={correlationVector}></div>
    </LocationTracker>
  ),
  partnerConfigurations,
};

registerGtlClientSide();
initializeClient(clientOptions);
